import LandingImage from "./LandingImage";
import ProjectDescription from "./ProjectDescription";
import CustomMap from "./CustomMap";
import Gallery from "./Gallery";
import ContactInfo from "./ContactInfo";
import DiscoverTheCity from "./DiscoverTheCity";
import NavBar from "./NavBar";
import Footer from "./Footer";
import MasterPlan from "./MasterPlan";
const Home = () => {
    return <>
        <NavBar />
        <div className='app-container' id='home'>
        <LandingImage/>
        <ProjectDescription/>
        <Gallery/>
        <CustomMap />
        <MasterPlan />
        <DiscoverTheCity/>
        <ContactInfo/>
    </div>
        <Footer />
    </>
}

export default Home;
